import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import {
  Button,
  Form,
  Col,
  Modal,
  Row,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { Spin } from "antd";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomPhoneInput from "../../../CustomControls/CustomPhoneInput";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import CustomSelect from "../../../CustomControls/CustomSelect";
import { SVGICON } from "../../../constant/theme";
import { post, postFormData } from "../../../helpers/api_helper";
import {
  POST_BranchLetterHeadImageUpload,
  POST_BrancheInsert,
  POST_BranchesUpdate,
  POST_GetBranchDetailByID,
  POST_GetCategoryDropDownListByCategoryType,
  POST_ValidateLicenseLimit,
} from "../../../helpers/url_helper";
import QuickAddCategory from "../Categories/QuickAddCategory";
// import swal from "sweetalert";
import {
  capitalizeString,
  delete_RecordWithoutApi,
  errorMessage,
  successMessage,
  validateEmailField,
  validateMobileNoField,
  warningMessage,
} from "../CommonFunctions";

const AddBranch = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();

  const [country, setCountry] = useState("");

  const [cityOptions, setCityOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);

  const [addBankModal, setAddBankModal] = useState(false);

  const [showQuickAddCategoryModal, setShowQuickAddCategoryModal] =
    useState(false);
  const [categoryType, setCategoryType] = useState(0);
  const [parentCategoryID, setParentCategoryID] = useState(0);
  const [categoryTypeName, setCategoryTypeName] = useState("");

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  // const reportingSignatureOptions = [
  //   { label: "Digital", value: 1 },
  //   { label: "Manual", value: 2 },
  // ];

  const uLRNoGenerationTypeOptions = [
    { label: "TC Allocation", value: 1 },
    { label: "Report Printing", value: 2 },
  ];

  // const reportPrintingPaperTypeOptions = [
  //   { label: "Blank Paper", value: 1 },
  //   { label: "Letter Head Paper", value: 2 },
  // ];

  // const reportPrintingHeaderTypeOptions = [
  //   { label: "Default", value: 0 },
  //   { label: "First Page Only Header Detail", value: 1 },
  // ];

  // const reportPrintingPerPageImageLimitOptions = [
  //   { label: "2", value: 2 },
  //   { label: "4", value: 4 },
  //   { label: "6", value: 6 },
  // ];

  const getCountryDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 1, // 1 = Country
      ParentCategoryID: 0,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCountryOptions(
            response?.List?.map((item) => ({
              label: item.CategoryName,
              value: item.CategoryID,
            })),
          );

          if (response?.List?.length == 1 && !PrimaryIdParam) {
            formik.setFieldValue("CountryID", response?.List[0].CategoryID);
            getStateDDL(response?.List[0].CategoryID);
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getStateDDL = async (CountryID) => {
    setIsLoading(true);
    await post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 2, // 2 = State
      ParentCategoryID: CountryID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setStateOptions(
            response?.List?.map((item) => ({
              label: item.CategoryName,
              value: item.CategoryID,
            })),
          );

          if (response?.List?.length == 1 && !PrimaryIdParam) {
            formik.setFieldValue("StateID", response?.List[0].CategoryID);
            getCityDDL(response?.List[0].CategoryID);
          }

          if (
            response?.List?.length > 0 &&
            StateID &&
            response?.List?.filter((x) => x.CategoryID == StateID).length == 0
          ) {
            formik.setFieldValue("StateID", "");
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getCityDDL = async (StateID) => {
    setIsLoading(true);
    await post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 3, // 3 = City
      ParentCategoryID: StateID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCityOptions(
            response?.List?.map((item) => ({
              label: item.CategoryName,
              value: item.CategoryID,
            })),
          );
          if (response?.List?.length == 1 && !PrimaryIdParam) {
            formik.setFieldValue("CityID", response?.List[0].CategoryID);
          }

          if (
            response?.List?.length > 0 &&
            CityID &&
            response?.List?.filter((x) => x.CategoryID == CityID).length == 0
          ) {
            formik.setFieldValue("CityID", "");
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const validationSchema = Yup.object().shape({
    BranchName: Yup.string().trim().required("Branch Name is required field"),
    MobileNo: Yup.string().trim().required("Mobile No is required field"),
    Address: Yup.string().trim().required("Address  is required field"),
    CountryID: Yup.string().trim().required("Country Name is required field"),
    StateID: Yup.string().trim().required("State Name is required field"),
    CityID: Yup.string().trim().required("City Name is required field"),
    Retest: Yup.string().trim().required("Retest is required field"),
    Rewise: Yup.string().trim().required("Revise is required field"),
    Amendment: Yup.string().trim().required("Amendment is required field"),
    TestMethodValidityDays: Yup.string()
      .trim()
      .required("Test Method Validity Days is required field"),
    ReferenceStandardsValidityDays: Yup.string()
      .trim()
      .required("Reference Standards Validity Days is required field"),
    EmailID: Yup.string().trim().required("EmailID is required field"),

    // LetterHeadHeaderImageWidth: Yup.string().when(
    //   "ReportPrintingPaperType",
    //   ([ReportPrintingPaperType], schema) => {
    //     if (ReportPrintingPaperType == 1)
    //       return Yup.string().required(
    //         "Letter Head Header Width is required field"
    //       );
    //     return schema;
    //   }
    // ),

    // LetterHeadHeaderImageHeight: Yup.string().when(
    //   "ReportPrintingPaperType",
    //   ([ReportPrintingPaperType], schema) => {
    //     if (ReportPrintingPaperType == 1)
    //       return Yup.string().required(
    //         "Letter Head Header Height is required field"
    //       );
    //     return schema;
    //   }
    // ),

    // LetterHeadFooterImageWidth: Yup.string().when(
    //   "ReportPrintingPaperType",
    //   ([ReportPrintingPaperType], schema) => {
    //     if (ReportPrintingPaperType == 1)
    //       if (
    //         LetterHeadFooterImageFilePath !== "" ||
    //         LetterHeadFooterImageFileUrl !== ""
    //       ) {
    //         return Yup.string().required(
    //           "Letter Head Footer Width is required field"
    //         );
    //       }
    //     return schema;
    //   }
    // ),

    // LetterHeadFooterImageHeight: Yup.string().when(
    //   "ReportPrintingPaperType",
    //   ([ReportPrintingPaperType], schema) => {
    //     if (ReportPrintingPaperType == 1)
    //       if (
    //         LetterHeadFooterImageFilePath !== "" ||
    //         LetterHeadFooterImageFileUrl !== ""
    //       ) {
    //         return Yup.string().required(
    //           "Letter Head Footer Height is required field"
    //         );
    //       }
    //     return schema;
    //   }
    // ),

    // LetterHeadHeaderImageFilePath: Yup.string().when(
    //   "ReportPrintingPaperType",
    //   ([ReportPrintingPaperType], schema) => {
    //     if (ReportPrintingPaperType == 1)
    //       if (LetterHeadHeaderImageFileUrl == "") {
    //         return Yup.string().required(
    //           "Letter Head Header Image File is required field"
    //         );
    //       }
    //     return schema;
    //   }
    // ),

    // // LetterHeadFooterImageFilePath: Yup.string().when(
    // //   "ReportPrintingPaperType",
    // //   ([ReportPrintingPaperType], schema) => {
    // //     if (ReportPrintingPaperType == 1)
    // //       if (LetterHeadFooterImageFileUrl == "") {
    // //         return Yup.string().required(
    // //           "Letter Head Footer Image File is required field"
    // //         );
    // //       }
    // //     return schema;
    // //   }
    // // ),

    // NABLLogoWidth: Yup.string().when(
    //   "IsLetterHeadImageWithNABLLogo",
    //   ([IsLetterHeadImageWithNABLLogo], schema) => {
    //     if (IsLetterHeadImageWithNABLLogo == false)
    //       return Yup.string().required(
    //         "Letter Head NABL Logo Width is required field"
    //       );
    //     return schema;
    //   }
    // ),

    // NABLLogoHeight: Yup.string().when(
    //   "IsLetterHeadImageWithNABLLogo",
    //   ([IsLetterHeadImageWithNABLLogo], schema) => {
    //     if (IsLetterHeadImageWithNABLLogo == false)
    //       return Yup.string().required(
    //         "Letter Head NABL Logo Height is required field"
    //       );
    //     return schema;
    //   }
    // ),

    // LeftMarginToPrintNABLLogo: Yup.string().when(
    //   "IsLetterHeadImageWithNABLLogo",
    //   ([IsLetterHeadImageWithNABLLogo], schema) => {
    //     if (IsLetterHeadImageWithNABLLogo == false)
    //       return Yup.string().required(
    //         "Header Left Margin NABL Logo is required field"
    //       );
    //     return schema;
    //   }
    // ),

    // TopMarginToPrintNABLLogo: Yup.string().when(
    //   "IsLetterHeadImageWithNABLLogo",
    //   ([IsLetterHeadImageWithNABLLogo], schema) => {
    //     if (IsLetterHeadImageWithNABLLogo == false)
    //       return Yup.string().required(
    //         "Header Top Margin NABL Logo is required field"
    //       );
    //     return schema;
    //   }
    // ),

    // NABLLogoFilePath: Yup.string().when(
    //   "IsLetterHeadImageWithNABLLogo",
    //   ([IsLetterHeadImageWithNABLLogo], schema) => {
    //     if (IsLetterHeadImageWithNABLLogo == false)
    //       if (NABLLogoFileUrl == "") {
    //         return Yup.string().required("NABL Logo File is required field");
    //       }
    //     return schema;
    //   }
    // ),

    // PrePrintedStationaryHeaderHeight: Yup.string().when(
    //   "ReportPrintingPaperType",
    //   ([ReportPrintingPaperType], schema) => {
    //     if (ReportPrintingPaperType == 2)
    //       return Yup.string().required(
    //         "Pre-Printed Stationary Header Height is required field"
    //       );
    //     return schema;
    //   }
    // ),

    // PrePrintedStationaryFooterHeight: Yup.string().when(
    //   "ReportPrintingPaperType",
    //   ([ReportPrintingPaperType], schema) => {
    //     if (ReportPrintingPaperType == 2)
    //       return Yup.string().required(
    //         "Pre-Printed Stationary Footer Height is required field"
    //       );
    //     return schema;
    //   }
    // ),

    // InvoicePrePrintedStationaryHeaderHeight: Yup.string().when(
    //   "InvoicePrintingPaperType",
    //   ([InvoicePrintingPaperType], schema) => {
    //     if (
    //       InvoicePrintingPaperType == 2 &&
    //       AuthUser?.Permissions?.Account == 1
    //     )
    //       return Yup.string().required(
    //         "Invoice Pre-Printed Stationary Header Height is required field"
    //       );
    //     return schema;
    //   }
    // ),

    // InvoiceLetterHeadHeaderImageWidth: Yup.string().when(
    //   "InvoicePrintingPaperType",
    //   ([InvoicePrintingPaperType], schema) => {
    //     if (
    //       InvoicePrintingPaperType == 1 &&
    //       AuthUser?.Permissions?.Account == 1
    //     )
    //       return Yup.string().required(
    //         "Invoice Letter Head Header Width is required field"
    //       );
    //     return schema;
    //   }
    // ),

    // InvoiceLetterHeadHeaderImageHeight: Yup.string().when(
    //   "InvoicePrintingPaperType",
    //   ([InvoicePrintingPaperType], schema) => {
    //     if (
    //       InvoicePrintingPaperType == 1 &&
    //       AuthUser?.Permissions?.Account == 1
    //     )
    //       return Yup.string().required(
    //         "Invoice Letter Head Header Height is required field"
    //       );
    //     return schema;
    //   }
    // ),

    // InvoiceLetterHeadHeaderImageFilePath: Yup.string().when(
    //   "InvoicePrintingPaperType",
    //   ([InvoicePrintingPaperType], schema) => {
    //     if (
    //       InvoicePrintingPaperType == 1 &&
    //       AuthUser?.Permissions?.Account == 1
    //     )
    //       if (InvoiceLetterHeadHeaderImageFileUrl == "") {
    //         return Yup.string().required(
    //           "Invoice Letter Head Header Image File is required field"
    //         );
    //       }
    //     return schema;
    //   }
    // ),

    // MachinResultCSVFilePath: Yup.string()
    //   .trim()
    //   .required("Machin Result CSV File Path is required field"),
    // MachinResultCSVFileReadIntervalTime: Yup.string()
    //   .trim()
    //   .required("Machin Result CSV File Read Interval Time is required field"),
    // MachinResultCSVFileTCNoColumnName: Yup.string()
    //   .trim()
    //   .required("Machin Result CSV File TCNo Column Name is required field"),
    // MachinResultCSVFileTestCountColumnName: Yup.string()
    //   .trim()
    //   .required(
    //     "Machin Result CSV File Test Count Column Name is required field"
    //   ),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      BranchIDEncrypt: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      BranchName: "",
      Address: "",
      CityID: "",
      StateID: "",
      CountryID: "",
      CountryCode: "+91",
      MobileNo: "",
      MobileNoFormat: "",
      EmailID: "",
      ListOfBranchBankDetail: [],
      BranchParameterIDEncrypt: "",
      TestMethodValidityDays: "180",
      ReferenceStandardsValidityDays: "180",
      HSNNo: "",
      // ReportingSignature: 2,
      InwardApprovalRequired: false,
      TestingApprovalRequired: false,
      ULRNoGenerationType: 1,
      NABLLocation: "",
      // LetterHeadHeaderImageFilePath: "",
      // LetterHeadHeaderImageFilekey: "",
      // LetterHeadHeaderImageFileUrl: "",
      // LetterHeadHeaderImageWidth: "",
      // LetterHeadHeaderImageHeight: "",
      // LetterHeadFooterImageFilePath: "",
      // LetterHeadFooterImageFileKey: "",
      // LetterHeadFooterImageFileUrl: "",
      // LetterHeadFooterImageWidth: "",
      // LetterHeadFooterImageHeight: "",
      // NABLLogoFilePath: "",
      // NABLLogoFileKey: "",
      // NABLLogoFileUrl: "",
      // NABLLogoWidth: "",
      // NABLLogoHeight: "",
      // IsLetterHeadImageWithNABLLogo: false,
      // LeftMarginToPrintNABLLogo: "",
      // TopMarginToPrintNABLLogo: "",
      // ReportPrintingPaperType: 1,
      // PrePrintedStationaryHeaderHeight: "",
      // PrePrintedStationaryFooterHeight: "",
      Retest: "RT",
      Rewise: "R",
      Amendment: "AMD",
      PiValueType: 1,
      // InvoicePrintingPaperType: 1,
      // InvoiceLetterHeadHeaderImageFilePath: "",
      // InvoiceLetterHeadHeaderImageFilekey: "",
      // InvoiceLetterHeadHeaderImageFileUrl: "",
      // InvoiceLetterHeadHeaderImageWidth: "",
      // InvoiceLetterHeadHeaderImageHeight: "",
      // InvoicePrePrintedStationaryHeaderHeight: "",
      MachinResultCSVFilePath: "",
      MachinResultCSVFileReadIntervalPeriod: "60",
      MachinResultCSVFileTCNoColumnName: "",
      MachinResultCSVFileTestCountColumnName: "",
      TestingAfterSaveStayOnEntryScreen: false,
      InwardClubing: false,
      // ReportPrintingHeaderType: 0,
      // ReportPrintingPerPageImageLimit: 6,
      // ReportPrintingFirstPageDisclaimer: "",
      // ReportPrintingFirstPageAuthorizedSignatoryName: "",
      // ReportPrintingFirstPageQualityManagerName: "",
      ReportPrintApprovalRequired: false,
    },
    validateOnBlur: false,
  });

  const {
    values: {
      BranchIDEncrypt,
      CountryCode,
      ListOfBranchBankDetail,
      CountryID,
      StateID,
      CityID,
      InwardApprovalRequired,
      TestingApprovalRequired,
      // IsLetterHeadImageWithNABLLogo,
      // LetterHeadHeaderImageFilePath,
      // LetterHeadHeaderImageFileKey,
      // LetterHeadHeaderImageFileUrl,
      // LetterHeadFooterImageFilePath,
      // LetterHeadFooterImageFileKey,
      // LetterHeadFooterImageFileUrl,
      // NABLLogoFilePath,
      // NABLLogoFileKey,
      // NABLLogoFileUrl,
      // LetterHeadHeaderImageWidth,
      // LetterHeadFooterImageWidth,
      // NABLLogoWidth,
      // InvoicePrintingPaperType,
      // InvoiceLetterHeadHeaderImageFilePath,
      // InvoiceLetterHeadHeaderImageFileKey,
      // InvoiceLetterHeadHeaderImageFileUrl,
      // InvoiceLetterHeadHeaderImageWidth,
      // InvoiceLetterHeadHeaderImageHeight,
      // InvoicePrePrintedStationaryHeaderHeight,
      MachinResultCSVFilePath,
      MachinResultCSVFileReadIntervalPeriod,
      MachinResultCSVFileTCNoColumnName,
      MachinResultCSVFileTestCountColumnName,
      ReportPrintingHeaderType,
      TestingAfterSaveStayOnEntryScreen,
      InwardClubing,
      ReportPrintApprovalRequired,
    },
  } = formik;

  const handleValidSubmit = (values) => {
    if (
      !validateMobileNoField(
        values?.MobileNoFormat,
        CountryCode,
        values?.MobileNo,
      )
    ) {
      formik.setFieldError("MobileNo", "Please enter a valid mobile number");
      formik.setFieldTouched("MobileNo", true);
      return false;
    }

    if (
      values?.ListOfBranchBankDetail?.filter((x) => x?.IsDeleted == false)
        ?.length == 0
    ) {
      formik.setFieldError(
        "ListOfBranchBankDetail",
        "Branch Bank Detail is required",
      );
      formik.setFieldTouched("ListOfBranchBankDetail", true);

      return;
    }

    setIsLoading(true);
    let payload = {
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: values?.BranchIDEncrypt,
      BranchParameterIDEncrypt: values?.BranchParameterIDEncrypt,
      BranchName: values?.BranchName,
      Address: values?.Address,
      CityID: values?.CityID,
      StateID: values?.StateID,
      CountryID: values?.CountryID,
      CountryCode: "+" + values?.CountryCode.replace(/\+/g, ""),
      MobileNo: values?.MobileNo,
      EmailID: values?.EmailID,
      TestMethodValidityDays: values?.TestMethodValidityDays
        ? values?.TestMethodValidityDays
        : 0,
      ReferenceStandardsValidityDays: values?.ReferenceStandardsValidityDays
        ? values?.ReferenceStandardsValidityDays
        : 0,
      HSNNo: values?.HSNNo,
      // ReportingSignature: values?.ReportingSignature
      //   ? values?.ReportingSignature
      //   : 2,
      InwardApprovalRequired:
        AuthUser?.Permissions?.ApprovalWorkflow == 1
          ? values?.InwardApprovalRequired
          : false,
      TestingApprovalRequired:
        AuthUser?.Permissions?.ApprovalWorkflow == 1
          ? values?.TestingApprovalRequired
          : false,
      ULRNoGenerationType: values?.ULRNoGenerationType
        ? values?.ULRNoGenerationType
        : 1,
      NABLLocation: values?.NABLLocation ? values?.NABLLocation : 0,

      Retest: values?.Retest ? values?.Retest : "RT",
      Rewise: values?.Rewise ? values?.Rewise : "R",
      Amendment: values?.Amendment ? values?.Amendment : "AMD",
      PiValueType: values?.PiValueType ? values?.PiValueType : 1,

      MachinResultCSVFilePath: values?.MachinResultCSVFilePath,
      MachinResultCSVFileReadIntervalPeriod:
        values?.MachinResultCSVFileReadIntervalPeriod
          ? values?.MachinResultCSVFileReadIntervalPeriod
          : "60",
      MachinResultCSVFileTCNoColumnName:
        values?.MachinResultCSVFileTCNoColumnName,
      MachinResultCSVFileTestCountColumnName:
        values?.MachinResultCSVFileTestCountColumnName,
      TestingAfterSaveStayOnEntryScreen:
        values?.TestingAfterSaveStayOnEntryScreen,
      InwardClubing: values?.InwardClubing,
      ReportPrintApprovalRequired:
        AuthUser?.Permissions?.ApprovalWorkflow === 1
          ? values?.ReportPrintApprovalRequired
          : false,

      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ListOfBranchBankDetail: values?.ListOfBranchBankDetail,
    };
    //console.log("payload: ", payload);

    post(PrimaryIdParam ? POST_BranchesUpdate : POST_BrancheInsert, payload)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          if (AuthUser?.IsBranchDefinationComplate == false) {
            var obj = JSON.parse(localStorage.getItem("userDetails"));
            obj.IsBranchDefinationComplate = true;
            localStorage.setItem("userDetails", JSON.stringify(obj));
          }
          successMessage(response?.Message);
          // saveBranchLetterHeadImages(response?.EncryptID, values);
          setTimeout(() => {
            navigate("/branches");
          }, 1000);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        // setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  // const saveBranchLetterHeadImages = (branchID, values) => {
  //   setIsLoading(true);
  //   let formData = new FormData();
  //   formData.append("BranchIDEncrypt", branchID);
  //   // formData.append(
  //   //   "LetterHeadHeaderImageFilePath",
  //   //   values?.LetterHeadHeaderImageFilePath
  //   // );
  //   // formData.append(
  //   //   "LetterHeadHeaderImageFileUrl",
  //   //   values?.LetterHeadHeaderImageFileUrl
  //   // );
  //   // formData.append(
  //   //   "LetterHeadHeaderImageWidth",
  //   //   values?.LetterHeadHeaderImageWidth
  //   // );
  //   // formData.append(
  //   //   "LetterHeadHeaderImageHeight",
  //   //   values?.LetterHeadHeaderImageHeight
  //   // );
  //   // formData.append(
  //   //   "LetterHeadFooterImageFilePath",
  //   //   values?.LetterHeadFooterImageFilePath
  //   // );
  //   // formData.append(
  //   //   "LetterHeadFooterImageFileUrl",
  //   //   values?.LetterHeadFooterImageFileUrl
  //   // );
  //   // formData.append(
  //   //   "LetterHeadFooterImageWidth",
  //   //   values?.LetterHeadFooterImageWidth
  //   // );
  //   // formData.append(
  //   //   "LetterHeadFooterImageHeight",
  //   //   values?.LetterHeadFooterImageHeight
  //   // );
  //   // formData.append("NABLLogoFilePath", values?.NABLLogoFilePath);
  //   // formData.append("NABLLogoFileUrl", values?.NABLLogoFileUrl);
  //   // formData.append("NABLLogoWidth", values?.NABLLogoWidth);
  //   // formData.append("NABLLogoHeight", values?.NABLLogoHeight);
  //   // formData.append(
  //   //   "IsLetterHeadImageWithNABLLogo",
  //   //   values?.IsLetterHeadImageWithNABLLogo
  //   // );
  //   // formData.append(
  //   //   "LeftMarginToPrintNABLLogo",
  //   //   values?.LeftMarginToPrintNABLLogo
  //   // );
  //   // formData.append(
  //   //   "TopMarginToPrintNABLLogo",
  //   //   values?.TopMarginToPrintNABLLogo
  //   // );
  //   // formData.append(
  //   //   "ReportPrintingPaperType",
  //   //   values?.ReportPrintingPaperType ? values?.ReportPrintingPaperType : 1
  //   // );
  //   // formData.append(
  //   //   "PrePrintedStationaryHeaderHeight",
  //   //   values?.PrePrintedStationaryHeaderHeight
  //   // );
  //   // formData.append(
  //   //   "PrePrintedStationaryFooterHeight",
  //   //   values?.PrePrintedStationaryFooterHeight
  //   // );

  //   formData.append(
  //     "InvoicePrintingPaperType",
  //     values?.InvoicePrintingPaperType ? values?.InvoicePrintingPaperType : 1
  //   );
  //   formData.append(
  //     "InvoicePrePrintedStationaryHeaderHeight",
  //     values?.InvoicePrePrintedStationaryHeaderHeight
  //   );

  //   formData.append(
  //     "InvoiceLetterHeadHeaderImageFilePath",
  //     values?.InvoiceLetterHeadHeaderImageFilePath
  //   );
  //   formData.append(
  //     "InvoiceLetterHeadHeaderImageFileUrl",
  //     values?.InvoiceLetterHeadHeaderImageFileUrl
  //   );
  //   formData.append(
  //     "InvoiceLetterHeadHeaderImageWidth",
  //     values?.InvoiceLetterHeadHeaderImageWidth
  //   );
  //   formData.append(
  //     "InvoiceLetterHeadHeaderImageHeight",
  //     values?.InvoiceLetterHeadHeaderImageHeight
  //   );
  //   // formData.append(
  //   //   "ReportPrintingHeaderType",
  //   //   values?.ReportPrintingHeaderType
  //   // );
  //   // formData.append(
  //   //   "ReportPrintingPerPageImageLimit",
  //   //   values?.ReportPrintingPerPageImageLimit
  //   // );
  //   // formData.append(
  //   //   "ReportPrintingFirstPageDisclaimer",
  //   //   values?.ReportPrintingFirstPageDisclaimer
  //   // );
  //   // formData.append(
  //   //   "ReportPrintingFirstPageAuthorizedSignatoryName",
  //   //   values?.ReportPrintingFirstPageAuthorizedSignatoryName
  //   // );
  //   // formData.append(
  //   //   "ReportPrintingFirstPageQualityManagerName",
  //   //   values?.ReportPrintingFirstPageQualityManagerName
  //   // );

  //   postFormData(POST_BranchLetterHeadImageUpload, formData)
  //     .then((response) => {
  //       setIsLoading(true);
  //       if (response?.IsSuccess) {
  //         //swal("Success!", response?.Message, "success");
  //         successMessage(response?.Message);
  //         setTimeout(() => {
  //           navigate("/branches");
  //         }, 1000);
  //       } else {
  //         // swal("Error!", response?.Message, "error");
  //         errorMessage(response?.Message);
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  const validationSchemaBankDetail = Yup.object().shape({
    BankName: Yup.string().trim().required("Bank Name is required field"),
    AccountNumber: Yup.string().trim().required("A/c Number is required field"),
    IFSCCode: Yup.string().trim().required("IFSC Code is required field"),
    BranchName: Yup.string().trim().required("Branch is required field"),
  });

  const formikBankDetail = useFormik({
    validationSchema: validationSchemaBankDetail,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitBankDetail(values, formikHelpers),
    initialValues: {
      BranchBankIDEncrypt: "",
      BranchIDEncrypt: "",
      BankName: "",
      AccountNumber: "",
      BranchName: "",
      IFSCCode: "",
      IsDeleted: false,
      indx: "",
      actionFlag: 0, // 0 = Add,  1 = edit
    },
    validateOnBlur: false,
  });

  const {
    values: { actionFlag },
  } = formikBankDetail;

  const handleValidSubmitBankDetail = (values) => {
    if (values?.indx !== "") {
      formik.setFieldValue(
        "ListOfBranchBankDetail",
        ListOfBranchBankDetail?.map((x, idx) => {
          if (idx == values?.indx) {
            return {
              ...x,
              BankName: values?.BankName,
              AccountNumber: values?.AccountNumber,
              IFSCCode: values?.IFSCCode,
              BranchName: values?.BranchName,
            };
          } else {
            return { ...x };
          }
        }),
      );
    } else {
      formik.setFieldValue("ListOfBranchBankDetail", [
        ...ListOfBranchBankDetail,
        { ...values },
      ]);
    }
    setAddBankModal(false);
  };

  const addBank = () => {
    formikBankDetail.resetForm();
    setAddBankModal(true);
  };

  const editBank = (i) => {
    formikBankDetail.setValues({
      ...ListOfBranchBankDetail?.filter((x, idx) => idx == i)[0],
      indx: i,
    });
    formikBankDetail.setFieldValue("actionFlag", 1); // 1 = edit
    setAddBankModal(true);
  };

  const deleteBank = (i) => {
    if (ListOfBranchBankDetail[i]?.BranchBankIDEncrypt) {
      formik.setFieldValue(
        "ListOfBranchBankDetail",
        ListOfBranchBankDetail?.map((x, idx) => {
          if (idx == i) {
            return {
              ...x,
              IsDeleted: true,
            };
          } else {
            return { ...x };
          }
        }),
      );
    } else {
      formik.setFieldValue(
        "ListOfBranchBankDetail",
        ListOfBranchBankDetail?.filter((x, idx) => idx != i),
      );
    }
  };

  useEffect(() => {
    if (PrimaryIdParam) {
      getCountryDDL();
      getBranchDetailsByID();
    } else {
      validateLicenseLimit();
    }
  }, []);

  const validateLicenseLimit = async () => {
    setIsLoading(true);
    await post(POST_ValidateLicenseLimit, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      LoginIDEncrypted: AuthUser?.LoginIDEncrypt,
      FormNo: 42, //Branch Defination
    })
      .then((response) => {
        if (response?.IsSuccess == false) {
          // navigate("/branches");
          navigate(-1);
        } else {
          getCountryDDL();
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (CountryID) {
      getStateDDL(CountryID);
    } else {
      setStateOptions([]);
      formik.setFieldValue("StateID", "");
    }
  }, [CountryID]);

  useEffect(() => {
    if (StateID) {
      getCityDDL(StateID);
    } else {
      setCityOptions([]);
      formik.setFieldValue("CityID", "");
    }
  }, [StateID]);

  const fnCallbackQuickAddCategory = (categoryID, categoryName) => {
    if (categoryType == 1) {
      // 1 = Country
      setCountryOptions([
        ...countryOptions,
        { label: categoryName, value: categoryID },
      ]);
      formik.setFieldValue("CountryID", categoryID);
    } else if (categoryType == 2) {
      // 2 = State
      setStateOptions([
        ...stateOptions,
        { label: categoryName, value: categoryID },
      ]);
      formik.setFieldValue("StateID", categoryID);
    } else if (categoryType == 3) {
      // 3 = City
      setCityOptions([
        ...cityOptions,
        { label: categoryName, value: categoryID },
      ]);
      formik.setFieldValue("CityID", categoryID);
    }
  };

  const getBranchDetailsByID = () => {
    setIsLoading(true);
    post(POST_GetBranchDetailByID, {
      BranchIDEncrypt: window.atob(PrimaryIdParam),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setValues({
            ...response,
            // LetterHeadHeaderImageFileUrl:
            //   response?.LetterHeadHeaderImageFilePath,
            // LetterHeadHeaderImageFilePath: "",
            // LetterHeadFooterImageFileUrl:
            //   response?.LetterHeadFooterImageFilePath,
            // LetterHeadFooterImageFilePath: "",
            // NABLLogoFileUrl: response?.NABLLogoFilePath,
            // NABLLogoFilePath: "",
            // InvoiceLetterHeadHeaderImageFileUrl:
            //   response?.InvoiceLetterHeadHeaderImageFilePath,
            // InvoiceLetterHeadHeaderImageFilePath: "",
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [showImageModal, setShowImageModal] = useState(false);
  const [imageTitle, setImageTitle] = useState("");
  const [imageSrc, setImageSrc] = useState("");
  const [imageWidth, setImageWidth] = useState("");

  // const uploadLetterHeadHeaderImageFile = (e) => {
  //   if (e?.target?.files[0]) {
  //     const file = e?.target?.files[0];
  //     var pattern = /(.png|.gif|.jpeg|.jpg)$/;

  //     if (!file.type.match(pattern)) {
  //       warningMessage("Select valid file!");
  //       formik.setFieldValue("LetterHeadHeaderImageFilePath", "");
  //       formik.setFieldValue(
  //         "LetterHeadHeaderImageFileKey",
  //         Math.random().toString(9).substring(2, 9)
  //       );
  //     } else {
  //       formik.setFieldValue("LetterHeadHeaderImageFilePath", file);
  //     }
  //   } else {
  //     formik.setFieldValue("LetterHeadHeaderImageFilePath", "");
  //     formik.setFieldValue(
  //       "LetterHeadHeaderImageFileKey",
  //       Math.random().toString(9).substring(2, 9)
  //     );
  //   }
  // };

  // const viewLetterHeadHeaderImage = (e) => {
  //   setImageSrc(
  //     LetterHeadHeaderImageFilePath
  //       ? URL.createObjectURL(LetterHeadHeaderImageFilePath)
  //       : LetterHeadHeaderImageFileUrl
  //   );
  //   setImageWidth(
  //     LetterHeadHeaderImageWidth ? LetterHeadHeaderImageWidth + "mm" : "210mm"
  //   );
  //   setImageTitle("Letter Head Header Image");
  //   setShowImageModal(true);
  // };

  // const deleteLetterHeadHeaderImage = (e) => {
  //   formik.setFieldValue("LetterHeadHeaderImageFilePath", "");
  //   formik.setFieldValue(
  //     "LetterHeadHeaderImageFileKey",
  //     Math.random().toString(9).substring(2, 9)
  //   );
  //   formik.setFieldValue("LetterHeadHeaderImageFileUrl", "");
  // };

  // const uploadLetterHeadFooterImageFile = (e) => {
  //   if (e?.target?.files[0]) {
  //     const file = e?.target?.files[0];
  //     var pattern = /(.png|.gif|.jpeg|.jpg)$/;

  //     if (!file.type.match(pattern)) {
  //       warningMessage("Select valid file!");
  //       formik.setFieldValue("LetterHeadFooterImageFilePath", "");
  //       formik.setFieldValue(
  //         "LetterHeadFooterImageFileKey",
  //         Math.random().toString(9).substring(2, 9)
  //       );
  //     } else {
  //       formik.setFieldValue("LetterHeadFooterImageFilePath", file);
  //     }
  //   } else {
  //     formik.setFieldValue("LetterHeadFooterImageFilePath", "");
  //     formik.setFieldValue(
  //       "LetterHeadFooterImageFileKey",
  //       Math.random().toString(9).substring(2, 9)
  //     );
  //   }
  // };

  // const viewLetterHeadFooterImage = (e) => {
  //   setImageSrc(
  //     LetterHeadFooterImageFilePath
  //       ? URL.createObjectURL(LetterHeadFooterImageFilePath)
  //       : LetterHeadFooterImageFileUrl
  //   );
  //   setImageWidth(
  //     LetterHeadFooterImageWidth ? LetterHeadFooterImageWidth + "mm" : "210mm"
  //   );
  //   setImageTitle("Letter Head Footer Image");
  //   setShowImageModal(true);
  // };

  // const deleteLetterHeadFooterImage = (e) => {
  //   formik.setFieldValue("LetterHeadFooterImageFilePath", "");
  //   formik.setFieldValue(
  //     "LetterHeadFooterImageFileKey",
  //     Math.random().toString(9).substring(2, 9)
  //   );
  //   formik.setFieldValue("LetterHeadFooterImageFileUrl", "");
  // };

  // const uploadNABLLogoFile = (e) => {
  //   if (e?.target?.files[0]) {
  //     const file = e?.target?.files[0];
  //     var pattern = /(.png|.gif|.jpeg|.jpg)$/;

  //     if (!file.type.match(pattern)) {
  //       warningMessage("Select valid file!");
  //       formik.setFieldValue("NABLLogoFilePath", "");
  //       formik.setFieldValue(
  //         "NABLLogoFileKey",
  //         Math.random().toString(9).substring(2, 9)
  //       );
  //     } else {
  //       formik.setFieldValue("NABLLogoFilePath", file);
  //     }
  //   } else {
  //     formik.setFieldValue("NABLLogoFilePath", "");
  //     formik.setFieldValue(
  //       "NABLLogoFileKey",
  //       Math.random().toString(9).substring(2, 9)
  //     );
  //   }
  // };

  // const viewNABLLogo = (e) => {
  //   setImageSrc(
  //     NABLLogoFilePath ? URL.createObjectURL(NABLLogoFilePath) : NABLLogoFileUrl
  //   );
  //   setImageWidth(NABLLogoWidth ? NABLLogoWidth + "mm" : "32mm");
  //   setImageTitle("Letter Head NABL Logo Image");
  //   setShowImageModal(true);
  // };

  // const deleteNABLLogo = (e) => {
  //   formik.setFieldValue("NABLLogoFilePath", "");
  //   formik.setFieldValue(
  //     "NABLLogoFileKey",
  //     Math.random().toString(9).substring(2, 9)
  //   );
  //   formik.setFieldValue("NABLLogoFileUrl", "");
  // };

  // const deleteInvoiceLetterHeadHeaderImage = (e) => {
  //   formik.setFieldValue("InvoiceLetterHeadHeaderImageFilePath", "");
  //   formik.setFieldValue(
  //     "InvoiceLetterHeadHeaderImageFileKey",
  //     Math.random().toString(9).substring(2, 9)
  //   );
  //   formik.setFieldValue("InvoiceLetterHeadHeaderImageFileUrl", "");
  // };

  // const viewInvoiceLetterHeadHeaderImage = (e) => {
  //   setImageSrc(
  //     InvoiceLetterHeadHeaderImageFilePath
  //       ? URL.createObjectURL(InvoiceLetterHeadHeaderImageFilePath)
  //       : InvoiceLetterHeadHeaderImageFileUrl
  //   );
  //   setImageWidth(
  //     InvoiceLetterHeadHeaderImageWidth
  //       ? InvoiceLetterHeadHeaderImageWidth + "mm"
  //       : "210mm"
  //   );
  //   setImageTitle("Invoice Letter Head Header Image");
  //   setShowImageModal(true);
  // };

  // const uploadInvoiceLetterHeadHeaderImageFile = (e) => {
  //   if (e?.target?.files[0]) {
  //     const file = e?.target?.files[0];
  //     var pattern = /(.png|.gif|.jpeg|.jpg)$/;

  //     if (!file.type.match(pattern)) {
  //       warningMessage("Select valid file!");
  //       formik.setFieldValue("InvoiceLetterHeadHeaderImageFilePath", "");
  //       formik.setFieldValue(
  //         "InvoiceLetterHeadHeaderImageFileKey",
  //         Math.random().toString(9).substring(2, 9)
  //       );
  //     } else {
  //       formik.setFieldValue("InvoiceLetterHeadHeaderImageFilePath", file);
  //     }
  //   } else {
  //     formik.setFieldValue("InvoiceLetterHeadHeaderImageFilePath", "");
  //     formik.setFieldValue(
  //       "InvoiceLetterHeadHeaderImageFileKey",
  //       Math.random().toString(9).substring(2, 9)
  //     );
  //   }
  // };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="tbl-caption p-2">
            <h4 className="heading mb-0">
              {PrimaryIdParam ? "Edit" : "Add"} Branch
            </h4>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={3}>
                    <Field
                      label="Branch Name"
                      name="BranchName"
                      placeholder={"Enter Branch Name"}
                      component={CustomInput}
                      required
                      maxLength={200}
                      autoFocus
                      onChange={(e) => {
                        formik.setFieldValue(
                          "BranchName",
                          capitalizeString(e?.target?.value),
                        );
                      }}
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      label="Mobile No."
                      name="MobileNo"
                      placeholder={"Enter Mobile No."}
                      country={country}
                      countryCode={CountryCode}
                      component={CustomPhoneInput}
                      onChange={(value, { countryCode, dialCode }) => {
                        formik.setFieldValue("CountryCode", dialCode);
                        formik.setFieldValue(
                          "MobileNo",
                          value.substring(dialCode.toString().length),
                        );
                      }}
                      onFocus={(value, { format }) => {
                        formik.setFieldValue("MobileNoFormat", format);
                      }}
                      required
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      type="email"
                      label="Email"
                      name="EmailID"
                      placeholder={"Enter Email"}
                      component={CustomInput}
                      maxLength={100}
                      validate={validateEmailField}
                      required
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={3}>
                    <Field
                      label="Address"
                      name="Address"
                      rows={5}
                      placeholder={"Enter Address"}
                      component={CustomTextArea}
                      maxLength={500}
                      required
                    />
                  </Col>
                  <Col lg={3}>
                    {AuthUser?.UserType !== 1 ||
                    formsList?.filter((x) => x?.FormID == 7 && x?.IsAdd)
                      ?.length > 0 ? (
                      <Link
                        to="#"
                        className="icon-box icon-box-md bg-primary-light me-1"
                        title="New Country"
                        style={{ float: "right" }}
                        onClick={() => {
                          setCategoryType(1); // 1 = Country
                          setCategoryTypeName("Country");
                          setParentCategoryID(0);
                          setShowQuickAddCategoryModal(true);
                        }}
                      >
                        <i className="fa fa-plus"></i>
                      </Link>
                    ) : (
                      ""
                    )}
                    <Field
                      label="Country"
                      name="CountryID"
                      placeholder={"Select Country"}
                      component={CustomSelect}
                      options={countryOptions}
                      required
                    />
                  </Col>
                  <Col lg={3}>
                    {AuthUser?.UserType !== 1 ||
                    formsList?.filter((x) => x?.FormID == 7 && x?.IsAdd)
                      ?.length > 0 ? (
                      <Link
                        to="#"
                        className="icon-box icon-box-md bg-primary-light me-1"
                        title="New State"
                        style={{ float: "right" }}
                        onClick={() => {
                          if (CountryID) {
                            setCategoryType(2); // 2 = State
                            setCategoryTypeName("State");
                            setParentCategoryID(CountryID);
                            setShowQuickAddCategoryModal(true);
                          } else {
                            warningMessage("Please select Country first...");
                          }
                        }}
                      >
                        <i className="fa fa-plus"></i>
                      </Link>
                    ) : (
                      ""
                    )}
                    <Field
                      label="State"
                      name="StateID"
                      placeholder={"Select State"}
                      component={CustomSelect}
                      options={stateOptions}
                      required
                    />
                  </Col>
                  <Col lg={3}>
                    {AuthUser?.UserType !== 1 ||
                    formsList?.filter((x) => x?.FormID == 7 && x?.IsAdd)
                      ?.length > 0 ? (
                      <Link
                        to="#"
                        className="icon-box icon-box-md bg-primary-light me-1"
                        title="New City"
                        style={{ float: "right" }}
                        onClick={() => {
                          if (StateID) {
                            setCategoryType(3); // 3 = City
                            setCategoryTypeName("City");
                            setParentCategoryID(StateID);
                            setShowQuickAddCategoryModal(true);
                          } else {
                            warningMessage("Please select State first...");
                          }
                        }}
                      >
                        <i className="fa fa-plus"></i>
                      </Link>
                    ) : (
                      ""
                    )}
                    <Field
                      label="City"
                      name="CityID"
                      placeholder={"Select City"}
                      component={CustomSelect}
                      options={cityOptions}
                      required
                    />
                  </Col>
                </Row>
                <hr className="mt-1 mb-1"></hr>
                <div className="d-flex justify-content-between mb-2">
                  <h5 className="mb-0">General Parameters Details</h5>
                </div>
                {/* <hr className="mt-1 mb-1"></hr> */}
                <div className="">
                  <Row>
                    <Col lg={3}>
                      <label>
                        Test Method Validity Days
                        <i className="text-danger">*</i>&nbsp;
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1">
                                {" "}
                                This input field is used in the Test Method
                                Master to specify the validity period for each
                                declared method.
                              </strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{ cursor: "pointer", color: "#9698ab" }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <Field
                        type="number"
                        name="TestMethodValidityDays"
                        placeholder={"Enter Test Method Validity Days"}
                        component={CustomInput}
                        maxLength={50}
                      />
                    </Col>
                    <Col lg={3}>
                      <label>
                        Reference Standards Validity Days
                        <i className="text-danger">*</i>&nbsp;
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1">
                                {" "}
                                This input field is used in the Reference
                                Standard Master to specify the validity period
                                for each declared Reference Standard.
                              </strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{ cursor: "pointer", color: "#9698ab" }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <Field
                        type="number"
                        name="ReferenceStandardsValidityDays"
                        placeholder={"Enter Reference Standards Validity Days"}
                        component={CustomInput}
                        maxLength={50}
                      />
                    </Col>

                    <Col lg={3}>
                      <label>
                        HSN No{" "}
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1">
                                {" "}
                                HSN No will be used in the Invoice.
                              </strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{ cursor: "pointer", color: "#9698ab" }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <Field
                        name="HSNNo"
                        placeholder={"Enter HSN No"}
                        component={CustomInput}
                        maxLength={50}
                      />
                    </Col>

                    <Col lg={3}>
                      <label>
                        ULR No Generation Type{" "}
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1">
                                If set to "TC Allocation" the ULR No will get
                                generated while performing TC Allocation
                                transaction. When set to "Reporting" then ULR No
                                will get generated while performing reporting
                                transaction.
                              </strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{ cursor: "pointer", color: "#9698ab" }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <Field
                        name="ULRNoGenerationType"
                        placeholder={"Select Status"}
                        options={uLRNoGenerationTypeOptions}
                        component={CustomSelect}
                        isClearable={false}
                      />
                    </Col>
                    <Col lg={3}>
                      <label>
                        NABL Location{" "}
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1">
                                {" "}
                                Enter the NABL Lab Location Number to identify
                                the accredited laboratory's specific location.
                              </strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{ cursor: "pointer", color: "#9698ab" }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <Field
                        type="number"
                        name="NABLLocation"
                        placeholder={"Enter NABL Location"}
                        component={CustomInput}
                        onChange={(e) => {
                          if (e?.target?.value < 100) {
                            formik.setFieldValue(
                              "NABLLocation",
                              e?.target?.value,
                            );
                          }
                        }}
                      />
                    </Col>
                    {AuthUser?.LicenseTypeID != 5 && (
                      <>
                        <Col lg={3}>
                          <label>
                            Retest <i className="text-danger">*</i>&nbsp;
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    {" "}
                                    Specify a prefix to be automatically added
                                    to the sample number for retest
                                    transactions. This helps differentiate
                                    retests from original samples.
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>
                                <i
                                  className="fa fa-info-circle"
                                  style={{
                                    cursor: "pointer",
                                    color: "#9698ab",
                                  }}
                                ></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                          <Field
                            name="Retest"
                            placeholder={"Enter Retest"}
                            component={CustomInput}
                            maxLength={100}
                          />
                        </Col>
                        <Col lg={3}>
                          <label>
                            Revise<i className="text-danger">*</i>&nbsp;
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    Enter a prefix to be appended to the sample
                                    number for revise transactions. This ensures
                                    that revised samples are easily identifiable
                                    and distinct from original samples.
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>
                                <i
                                  className="fa fa-info-circle"
                                  style={{
                                    cursor: "pointer",
                                    color: "#9698ab",
                                  }}
                                ></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                          <Field
                            name="Rewise"
                            placeholder={"Enter Revise"}
                            component={CustomInput}
                            maxLength={100}
                          />
                        </Col>
                        {/* </Row>
                  <Row> */}
                        <Col lg={3}>
                          <label>
                            Amendment<i className="text-danger">*</i>&nbsp;
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    {" "}
                                    Enter a prefix to be appended to the sample
                                    number for amendment transactions. This
                                    helps in distinguishing amended samples from
                                    original ones.
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>
                                <i
                                  className="fa fa-info-circle"
                                  style={{
                                    cursor: "pointer",
                                    color: "#9698ab",
                                  }}
                                ></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                          <Field
                            name="Amendment"
                            placeholder={"Enter Amendment"}
                            component={CustomInput}
                            maxLength={100}
                          />
                        </Col>
                        {AuthUser?.Permissions?.ApprovalWorkflow == 1 && (
                          <>
                            <Col lg={3}>
                              <label>
                                Inward Approval Required{" "}
                                <OverlayTrigger
                                  trigger={["hover", "focus"]}
                                  responsive={true}
                                  overlay={
                                    <Tooltip className="toltip-popover">
                                      <strong className="p-1">
                                        {" "}
                                        If unchecked, the material inward will
                                        be automatically approved.
                                      </strong>
                                    </Tooltip>
                                  }
                                >
                                  <span>
                                    <i
                                      className="fa fa-info-circle"
                                      style={{
                                        cursor: "pointer",
                                        color: "#9698ab",
                                      }}
                                    ></i>
                                  </span>
                                </OverlayTrigger>
                              </label>
                              <div className="mb-2 form-control form-control-sm">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="InwardApprovalRequired"
                                  name="InwardApprovalRequired"
                                  checked={InwardApprovalRequired}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "InwardApprovalRequired",
                                      e.target.checked,
                                    );
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="InwardApprovalRequired"
                                >
                                  Inward Approval Required
                                </label>
                              </div>
                            </Col>
                            <Col lg={3}>
                              <label>
                                Testing Approval Required{" "}
                                <OverlayTrigger
                                  trigger={["hover", "focus"]}
                                  responsive={true}
                                  overlay={
                                    <Tooltip className="toltip-popover">
                                      <strong className="p-1">
                                        {" "}
                                        If unchecked, the testing transaction
                                        will be automatically approved.
                                      </strong>
                                    </Tooltip>
                                  }
                                >
                                  <span>
                                    <i
                                      className="fa fa-info-circle"
                                      style={{
                                        cursor: "pointer",
                                        color: "#9698ab",
                                      }}
                                    ></i>
                                  </span>
                                </OverlayTrigger>
                              </label>
                              <div className="mb-2 form-control form-control-sm">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="TestingApprovalRequired"
                                  name="TestingApprovalRequired"
                                  checked={TestingApprovalRequired}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "TestingApprovalRequired",
                                      e.target.checked,
                                    );
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="TestingApprovalRequired"
                                >
                                  Testing Approval Required
                                </label>
                              </div>
                            </Col>
                            <Col lg={3}>
                              <label>
                                Report Print Approval Required{" "}
                                <OverlayTrigger
                                  trigger={["hover", "focus"]}
                                  responsive={true}
                                  overlay={
                                    <Tooltip className="toltip-popover">
                                      <strong className="p-1">
                                        {" "}
                                        If unchecked, the report print
                                        transaction will be automatically
                                        approved.
                                      </strong>
                                    </Tooltip>
                                  }
                                >
                                  <span>
                                    <i
                                      className="fa fa-info-circle"
                                      style={{
                                        cursor: "pointer",
                                        color: "#9698ab",
                                      }}
                                    ></i>
                                  </span>
                                </OverlayTrigger>
                              </label>
                              <div className="mb-2 form-control form-control-sm">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="ReportPrintApprovalRequired"
                                  name="ReportPrintApprovalRequired"
                                  checked={ReportPrintApprovalRequired}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "ReportPrintApprovalRequired",
                                      e.target.checked,
                                    );
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="ReportPrintApprovalRequired"
                                >
                                  Report Print Approval Required
                                </label>
                              </div>
                            </Col>
                          </>
                        )}
                        <Col lg={3}>
                          <label>
                            Testing After Save Stay On Entry Screen{" "}
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    {" "}
                                    If Testing After Save Stay On Entry Screen
                                    values is YES then Stay On Entry Screen
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>
                                <i
                                  className="fa fa-info-circle"
                                  style={{
                                    cursor: "pointer",
                                    color: "#9698ab",
                                  }}
                                ></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                          <div className="mb-2 form-control form-control-sm">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="TestingAfterSaveStayOnEntryScreen"
                              name="TestingAfterSaveStayOnEntryScreen"
                              checked={TestingAfterSaveStayOnEntryScreen}
                              onChange={(e) => {
                                formik.setFieldValue(
                                  "TestingAfterSaveStayOnEntryScreen",
                                  e.target.checked,
                                );
                              }}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="TestingAfterSaveStayOnEntryScreen"
                            >
                              Testing After Save Stay On Entry Screen
                            </label>
                          </div>
                        </Col>
                      </>
                    )}
                    <Col lg={3}>
                      <label>
                        Inward Clubing{" "}
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1"> Inward Clubing</strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{ cursor: "pointer", color: "#9698ab" }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <div className="mb-2 form-control form-control-sm">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="InwardClubing"
                          name="InwardClubing"
                          checked={InwardClubing}
                          onChange={(e) => {
                            formik.setFieldValue(
                              "InwardClubing",
                              e.target.checked,
                            );
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="InwardClubing"
                        >
                          Inward Clubing
                        </label>
                      </div>
                    </Col>
                    {(AuthUser?.Permissions?.DT == 1 ||
                      AuthUser?.Permissions?.FoodTesting == 1) && (
                      <Col lg={3}>
                        <label>
                          Pi (π) &nbsp;
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            responsive={true}
                            overlay={
                              <Tooltip className="toltip-popover">
                                <strong className="p-1">
                                  {" "}
                                  Pi (π) will be used in the test parameter
                                  formula.
                                </strong>
                              </Tooltip>
                            }
                          >
                            <span>
                              <i
                                className="fa fa-info-circle"
                                style={{ cursor: "pointer", color: "#9698ab" }}
                              ></i>
                            </span>
                          </OverlayTrigger>
                        </label>
                        <div>
                          <div className="form-check custom-checkbox mb-2 form-check-inline ms-1">
                            <input
                              type="radio"
                              className="form-check-input"
                              id="customRadioPiValueType1"
                              name="PiValueType"
                              title="3.14"
                              style={{ cursor: "pointer" }}
                              checked={formik.values.PiValueType == 1}
                              onChange={() => {
                                formik.setFieldValue("PiValueType", 1);
                              }}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="customRadioPiValueType1"
                            >
                              3.14
                            </label>
                          </div>
                          <div className="form-check custom-checkbox mb-2 form-check-inline ms-1">
                            <input
                              type="radio"
                              className="form-check-input"
                              id="customRadioPiValueType2"
                              name="PiValueType"
                              title="22/7"
                              style={{ cursor: "pointer" }}
                              checked={formik.values.PiValueType == 2}
                              onChange={() => {
                                formik.setFieldValue("PiValueType", 2);
                              }}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="customRadioPiValueType2"
                            >
                              <sup>22</sup>&frasl;<sub>7</sub>
                            </label>
                          </div>
                        </div>
                      </Col>
                    )}
                  </Row>
                </div>
                {/*<hr className="mt-1 mb-1"></hr>
                 <div className="d-flex justify-content-between mb-2">
                  <h5 className="mb-0">Reporting Parameters Details</h5>
                </div>

                <div className="">
                  <Row>
                    <Col lg={3}>
                      <label>
                        Reporting Signature{" "}
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1">
                                {" "}
                                If set to 'Digital,' the signature uploaded in
                                the employee master record will be printed on
                                the report. If set to 'Manual,' the report will
                                need to be signed by hand after printing.
                              </strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{ cursor: "pointer", color: "#9698ab" }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <Field
                        name="ReportingSignature"
                        placeholder={"Select Status"}
                        options={reportingSignatureOptions}
                        component={CustomSelect}
                        isClearable={false}
                      />
                    </Col>
                    <Col lg={3}>
                      <label>
                        Report Print Paper Type{" "}
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1">
                                {" "}
                                Select the type of paper for printing reports:
                                'Blank Paper' or 'Letterhead Paper.'
                              </strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{ cursor: "pointer", color: "#9698ab" }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <Field
                        name="ReportPrintingPaperType"
                        placeholder={"Select Paper Type"}
                        options={reportPrintingPaperTypeOptions}
                        component={CustomSelect}
                        isClearable={false}
                      />
                    </Col>
                    <Col lg={3}>
                      {(LetterHeadHeaderImageFileUrl ||
                        LetterHeadHeaderImageFilePath) && (
                        <>
                          <Link
                            to="#"
                            className="icon-box icon-box-md me-1"
                            title="Delete"
                            style={{ float: "right" }}
                            onClick={deleteLetterHeadHeaderImage}
                          >
                            {SVGICON.DeleteDanger}
                          </Link>
                          <Link
                            to="#"
                            className="icon-box icon-box-md me-1"
                            title="View"
                            style={{ float: "right" }}
                            onClick={viewLetterHeadHeaderImage}
                          >
                            <i className="fa fa-image"></i>
                          </Link>
                        </>
                      )}
                      <div className="mb-2">
                        <label>
                          Letter Head Header Image{" "}
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            responsive={true}
                            overlay={
                              <Tooltip className="toltip-popover">
                                <strong className="p-1">
                                  {" "}
                                  Upload the image to be used as the header on
                                  letterhead paper for report printing.
                                </strong>
                              </Tooltip>
                            }
                          >
                            <span>
                              <i
                                className="fa fa-info-circle"
                                style={{ cursor: "pointer", color: "#9698ab" }}
                              ></i>
                            </span>
                          </OverlayTrigger>
                        </label>
                        <input
                          type="file"
                          className="form-control form-control-sm"
                          id="LetterHeadHeaderImageFilePath"
                          accept="image/png, image/gif, image/jpeg"
                          key={LetterHeadHeaderImageFileKey || ""}
                          onChange={(e) => {
                            uploadLetterHeadHeaderImageFile(e);
                          }}
                        />
                        <ErrorMessage
                          name="LetterHeadHeaderImageFilePath"
                          component="div"
                          className="invalid-feedback animated fadeInUp"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                    <Col lg={3}>
                      <label>
                        Letter Head Header Width x Height(mm){" "}
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1">
                                {" "}
                                Specify the dimensions of the letterhead header
                                image in millimeters to ensure proper alignment
                                on the paper.
                              </strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{ cursor: "pointer", color: "#9698ab" }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <div className="d-flex">
                        <Field
                          type="number"
                          name="LetterHeadHeaderImageWidth"
                          placeholder={"Width (mm)"}
                          component={CustomInput}
                          onChange={(e) => {
                            if (e?.target?.value < 211) {
                              formik.setFieldValue(
                                "LetterHeadHeaderImageWidth",
                                e?.target?.value
                              );
                            }
                          }}
                        />
                        <div className="mt-2 ms-1 me-1">x</div>
                        <Field
                          type="number"
                          name="LetterHeadHeaderImageHeight"
                          placeholder={"Height (mm)"}
                          component={CustomInput}
                          onChange={(e) => {
                            if (e?.target?.value < 100) {
                              formik.setFieldValue(
                                "LetterHeadHeaderImageHeight",
                                e?.target?.value
                              );
                            }
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={3}>
                      {(LetterHeadFooterImageFileUrl ||
                        LetterHeadFooterImageFilePath) && (
                        <>
                          <Link
                            to="#"
                            className="icon-box icon-box-md me-1"
                            title="Delete"
                            style={{ float: "right" }}
                            onClick={deleteLetterHeadFooterImage}
                          >
                            {SVGICON.DeleteDanger}
                          </Link>
                          <Link
                            to="#"
                            className="icon-box icon-box-md me-1"
                            title="View"
                            style={{ float: "right" }}
                            onClick={viewLetterHeadFooterImage}
                          >
                            <i className="fa fa-image"></i>
                          </Link>
                        </>
                      )}
                      <div className="mb-2">
                        <label>
                          Letter Head Footer Image{" "}
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            responsive={true}
                            overlay={
                              <Tooltip className="toltip-popover">
                                <strong className="p-1">
                                  {" "}
                                  Upload the image to be used in the header of
                                  the letterhead. Ensure the image is in the
                                  correct format and resolution for clear and
                                  professional presentation.
                                </strong>
                              </Tooltip>
                            }
                          >
                            <span>
                              <i
                                className="fa fa-info-circle"
                                style={{ cursor: "pointer", color: "#9698ab" }}
                              ></i>
                            </span>
                          </OverlayTrigger>
                        </label>
                        <input
                          type="file"
                          className="form-control form-control-sm"
                          id="LetterHeadFooterImageFilePath"
                          accept="image/png, image/gif, image/jpeg"
                          key={LetterHeadFooterImageFileKey || ""}
                          onChange={(e) => {
                            uploadLetterHeadFooterImageFile(e);
                          }}
                        />
                        <ErrorMessage
                          name="LetterHeadFooterImageFilePath"
                          component="div"
                          className="invalid-feedback animated fadeInUp"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                    <Col lg={3}>
                      <label>
                        Letter Head Footer Width x Height (mm){" "}
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1">
                                {" "}
                                Specify the dimensions for the footer section of
                                the letterhead. Ensure accurate measurements for
                                proper alignment and formatting on the printed
                                document.
                              </strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{ cursor: "pointer", color: "#9698ab" }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <div className="d-flex">
                        <Field
                          type="number"
                          name="LetterHeadFooterImageWidth"
                          placeholder={"Width (mm)"}
                          component={CustomInput}
                          onChange={(e) => {
                            if (e?.target?.value < 211) {
                              formik.setFieldValue(
                                "LetterHeadFooterImageWidth",
                                e?.target?.value
                              );
                            }
                          }}
                        />
                        <div className="mt-2 ms-1 me-1">x</div>
                        <Field
                          type="number"
                          name="LetterHeadFooterImageHeight"
                          placeholder={"Height (mm)"}
                          component={CustomInput}
                          onChange={(e) => {
                            if (e?.target?.value < 100) {
                              formik.setFieldValue(
                                "LetterHeadFooterImageHeight",
                                e?.target?.value
                              );
                            }
                          }}
                        />
                      </div>
                    </Col>

                    <Col lg={3}>
                      {(NABLLogoFileUrl || NABLLogoFilePath) && (
                        <>
                          <Link
                            to="#"
                            className="icon-box icon-box-md me-1"
                            title="Delete"
                            style={{ float: "right" }}
                            onClick={deleteNABLLogo}
                          >
                            {SVGICON.DeleteDanger}
                          </Link>
                          <Link
                            to="#"
                            className="icon-box icon-box-md me-1"
                            title="View"
                            style={{ float: "right" }}
                            onClick={viewNABLLogo}
                          >
                            <i className="fa fa-image"></i>
                          </Link>
                        </>
                      )}
                      <div className="mb-2">
                        <label>
                          NABL Logo{" "}
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            responsive={true}
                            overlay={
                              <Tooltip className="toltip-popover">
                                <strong className="p-1">
                                  Upload the NABL logo to be included on
                                  official documents. This logo represents
                                  accreditation and compliance with NABL
                                  standards.
                                </strong>
                              </Tooltip>
                            }
                          >
                            <span>
                              <i
                                className="fa fa-info-circle"
                                style={{ cursor: "pointer", color: "#9698ab" }}
                              ></i>
                            </span>
                          </OverlayTrigger>
                        </label>
                        <input
                          type="file"
                          className="form-control form-control-sm"
                          id="NABLLogoFilePath"
                          accept="image/png, image/gif, image/jpeg"
                          key={NABLLogoFileKey || ""}
                          onChange={(e) => {
                            uploadNABLLogoFile(e);
                          }}
                        />
                        <ErrorMessage
                          name="NABLLogoFilePath"
                          component="div"
                          className="invalid-feedback animated fadeInUp"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                    <Col lg={3}>
                      <label>
                        Letter Head NABL Logo Width x Height{" "}
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1">
                                Specify the dimensions (width x height) of the
                                NABL logo to be included on the letterhead.
                                Ensure that these measurements are accurate for
                                proper placement and scaling.
                              </strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{ cursor: "pointer", color: "#9698ab" }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <div className="d-flex">
                        <Field
                          type="number"
                          name="NABLLogoWidth"
                          placeholder={"Width (mm)"}
                          component={CustomInput}
                          onChange={(e) => {
                            if (e?.target?.value < 211) {
                              formik.setFieldValue(
                                "NABLLogoWidth",
                                e?.target?.value
                              );
                            }
                          }}
                        />
                        <div className="mt-2 ms-1 me-1">x</div>
                        <Field
                          type="number"
                          name="NABLLogoHeight"
                          placeholder={"Height (mm)"}
                          component={CustomInput}
                          onChange={(e) => {
                            if (e?.target?.value < 100) {
                              formik.setFieldValue(
                                "NABLLogoHeight",
                                e?.target?.value
                              );
                            }
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={3}>
                      <label>
                        Letter Head Image With NABL Logo{" "}
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1">
                                {" "}
                                Upload the image of the letterhead that includes
                                the NABL logo. This image will be used as the
                                template for official documents, ensuring that
                                the NABL logo is prominently displayed on your
                                letterhead.
                              </strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{ cursor: "pointer", color: "#9698ab" }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <div className="mb-2 form-control form-control-sm">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="IsLetterHeadImageWithNABLLogo"
                          name="IsLetterHeadImageWithNABLLogo"
                          checked={IsLetterHeadImageWithNABLLogo}
                          onChange={(e) => {
                            formik.setFieldValue(
                              "IsLetterHeadImageWithNABLLogo",
                              e.target.checked
                            );
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="IsLetterHeadImageWithNABLLogo"
                        >
                          Letter Head Image With NABL Logo
                        </label>
                      </div>
                    </Col>
                    <Col lg={3}>
                      <label>
                        Header Left - Top margin for NABL Logo{" "}
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1">
                                {" "}
                                Specify the top margin from the left edge of the
                                header where the NABL logo will be positioned.
                                This setting ensures proper alignment of the
                                NABL logo on your letterhead.
                              </strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{ cursor: "pointer", color: "#9698ab" }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <div className="d-flex">
                        <Field
                          type="number"
                          name="LeftMarginToPrintNABLLogo"
                          placeholder={"Left (mm)"}
                          component={CustomInput}
                          onChange={(e) => {
                            if (e?.target?.value < 211) {
                              formik.setFieldValue(
                                "LeftMarginToPrintNABLLogo",
                                e?.target?.value
                              );
                            }
                          }}
                        />
                        <div className="ms-1 me-1"></div>
                        <Field
                          type="number"
                          name="TopMarginToPrintNABLLogo"
                          placeholder={"Top (mm)"}
                          component={CustomInput}
                          onChange={(e) => {
                            if (e?.target?.value < 100) {
                              formik.setFieldValue(
                                "TopMarginToPrintNABLLogo",
                                e?.target?.value
                              );
                            }
                          }}
                        />
                      </div>
                    </Col>
                    <Col lg={3}>
                      <label>
                        Pre-Printed Stationary Header Height
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1">
                                {" "}
                                Specify the height of the header on pre-printed
                                stationary. This measurement ensures that the
                                content aligns correctly with the existing
                                header area.
                              </strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{ cursor: "pointer", color: "#9698ab" }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <Field
                        type="number"
                        name="PrePrintedStationaryHeaderHeight"
                        placeholder={"Height (mm)"}
                        component={CustomInput}
                        onChange={(e) => {
                          if (e?.target?.value < 100) {
                            formik.setFieldValue(
                              "PrePrintedStationaryHeaderHeight",
                              e?.target?.value
                            );
                          }
                        }}
                      />
                    </Col>
                    <Col lg={3}>
                      <label>
                        Pre-Printed Stationary Footer Height
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1">
                                {" "}
                                Specify the height of the footer on pre-printed
                                stationary. This measurement ensures that the
                                content aligns correctly with the existing
                                footer area.
                              </strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{ cursor: "pointer", color: "#9698ab" }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <Field
                        type="number"
                        name="PrePrintedStationaryFooterHeight"
                        placeholder={"Height (mm)"}
                        component={CustomInput}
                        onChange={(e) => {
                          if (e?.target?.value < 100) {
                            formik.setFieldValue(
                              "PrePrintedStationaryFooterHeight",
                              e?.target?.value
                            );
                          }
                        }}
                      />
                    </Col>
                    <Col lg={3}>
                      <label>
                        Report Print Header Type{" "}
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1">
                                Choose the type of header for printing report:
                                The 'Default' type repeats the header detail
                                when needed, while 'First Page Only Header
                                Detail' prints the header detail only on the
                                first page, with the test results starting from
                                the second page.
                              </strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{
                                cursor: "pointer",
                                color: "#9698ab",
                              }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <Field
                        name="ReportPrintingHeaderType"
                        placeholder={"Select Header Type"}
                        options={reportPrintingHeaderTypeOptions}
                        component={CustomSelect}
                        isClearable={false}
                      />
                    </Col>
                    {ReportPrintingHeaderType == 1 && (
                      <>
                        {" "}
                        <Col lg={3}>
                          <label>
                            Report Disclaimer{" "}
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    Set the Disclaimer to print on test report
                                    first page when report print header type is
                                    'First Page Only Header Detail'
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>
                                <i
                                  className="fa fa-info-circle"
                                  style={{
                                    cursor: "pointer",
                                    color: "#9698ab",
                                  }}
                                ></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                          <Field
                            name="ReportPrintingFirstPageDisclaimer"
                            placeholder={"Enter Disclaimer"}
                            component={CustomInput}
                            maxLength={1000}
                          />
                        </Col>
                        <Col lg={3}>
                          <label>
                            Report Authorized Signatory{" "}
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    Set the Authorized Signatory Name to print
                                    on test report first page when report print
                                    header type is 'First Page Only Header
                                    Detail'
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>
                                <i
                                  className="fa fa-info-circle"
                                  style={{
                                    cursor: "pointer",
                                    color: "#9698ab",
                                  }}
                                ></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                          <Field
                            name="ReportPrintingFirstPageAuthorizedSignatoryName"
                            placeholder={"Enter Authorized Signatory Name"}
                            component={CustomInput}
                            maxLength={100}
                          />
                        </Col>
                        <Col lg={3}>
                          <label>
                            Report Quality Manager{" "}
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    Set the Quality Manager Name to print on
                                    test report first page when report print
                                    header type is 'First Page Only Header
                                    Detail. If not required to print keep it
                                    blank.'
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>
                                <i
                                  className="fa fa-info-circle"
                                  style={{
                                    cursor: "pointer",
                                    color: "#9698ab",
                                  }}
                                ></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                          <Field
                            name="ReportPrintingFirstPageQualityManagerName"
                            placeholder={"Enter Quality Manager Name"}
                            component={CustomInput}
                            maxLength={100}
                          />
                        </Col>
                      </>
                    )}

                    <Col lg={3}>
                      <label>
                        Report Print Per Page Test Image{" "}
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1">
                                Set the number of images per page for printing
                                report
                              </strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{
                                cursor: "pointer",
                                color: "#9698ab",
                              }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <Field
                        name="ReportPrintingPerPageImageLimit"
                        placeholder={"Select Per Page Image"}
                        options={reportPrintingPerPageImageLimitOptions}
                        component={CustomSelect}
                        isClearable={false}
                      />
                    </Col>
                  </Row>
                </div> */}
                {/* {AuthUser?.Permissions?.Account == 1 ? (
                  <>
                    <hr className="mt-1 mb-1"></hr>
                    <div className="d-flex justify-content-between mb-2">
                      <h5 className="mb-0">Invoice Parameters Details</h5>
                    </div>
                    <div className="">
                      <Row>
                        <Col lg={3}>
                          <label>
                            Invoice Print Paper Type{" "}
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    Choose the type of paper for printing
                                    invoices: Blank Paper or Letterhead Paper.
                                    Select 'Letterhead Paper' if you want to use
                                    pre-printed stationery with a letterhead, or
                                    'Blank Paper' for standard printing on plain
                                    sheets.
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>
                                <i
                                  className="fa fa-info-circle"
                                  style={{
                                    cursor: "pointer",
                                    color: "#9698ab",
                                  }}
                                ></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                          <Field
                            name="InvoicePrintingPaperType"
                            placeholder={"Select Paper Type"}
                            options={reportPrintingPaperTypeOptions}
                            component={CustomSelect}
                            isClearable={false}
                          />
                        </Col>
                        <Col lg={3}>
                          {(InvoiceLetterHeadHeaderImageFileUrl ||
                            InvoiceLetterHeadHeaderImageFilePath) && (
                            <>
                              <Link
                                to="#"
                                className="icon-box icon-box-md me-1"
                                title="Delete"
                                style={{ float: "right" }}
                                onClick={deleteInvoiceLetterHeadHeaderImage}
                              >
                                {SVGICON.DeleteDanger}
                              </Link>
                              <Link
                                to="#"
                                className="icon-box icon-box-md me-1"
                                title="View"
                                style={{ float: "right" }}
                                onClick={viewInvoiceLetterHeadHeaderImage}
                              >
                                <i className="fa fa-image"></i>
                              </Link>
                            </>
                          )}
                          <div className="mb-2">
                            <label>
                              Invoice Letter Head Header Image{" "}
                              <OverlayTrigger
                                trigger={["hover", "focus"]}
                                responsive={true}
                                overlay={
                                  <Tooltip className="toltip-popover">
                                    <strong className="p-1">
                                      Upload the image to be used as the header
                                      on the invoice letterhead. This image will
                                      appear at the top of the invoice printout,
                                      typically including your company logo or
                                      other identifying information.
                                    </strong>
                                  </Tooltip>
                                }
                              >
                                <span>
                                  <i
                                    className="fa fa-info-circle"
                                    style={{
                                      cursor: "pointer",
                                      color: "#9698ab",
                                    }}
                                  ></i>
                                </span>
                              </OverlayTrigger>
                            </label>
                            <input
                              type="file"
                              className="form-control form-control-sm"
                              id="InvoiceLetterHeadHeaderImageFilePath"
                              accept="image/png, image/gif, image/jpeg"
                              key={InvoiceLetterHeadHeaderImageFileKey || ""}
                              onChange={(e) => {
                                uploadInvoiceLetterHeadHeaderImageFile(e);
                              }}
                            />
                            <ErrorMessage
                              name="InvoiceLetterHeadHeaderImageFilePath"
                              component="div"
                              className="invalid-feedback animated fadeInUp"
                              style={{ display: "block" }}
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <label>
                            Invoice Letter Head Header Width x Height(mm){" "}
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    Specify the width and height (in
                                    millimeters) for the header section of the
                                    invoice letterhead. This defines the area
                                    where the header image will be placed.
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>
                                <i
                                  className="fa fa-info-circle"
                                  style={{
                                    cursor: "pointer",
                                    color: "#9698ab",
                                  }}
                                ></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                          <div className="d-flex">
                            <Field
                              type="number"
                              name="InvoiceLetterHeadHeaderImageWidth"
                              placeholder={"Width (mm)"}
                              component={CustomInput}
                              onChange={(e) => {
                                if (e?.target?.value < 211) {
                                  formik.setFieldValue(
                                    "InvoiceLetterHeadHeaderImageWidth",
                                    e?.target?.value
                                  );
                                }
                              }}
                            />
                            <div className="mt-2 ms-1 me-1">x</div>
                            <Field
                              type="number"
                              name="InvoiceLetterHeadHeaderImageHeight"
                              placeholder={"Height (mm)"}
                              component={CustomInput}
                              onChange={(e) => {
                                if (e?.target?.value < 100) {
                                  formik.setFieldValue(
                                    "InvoiceLetterHeadHeaderImageHeight",
                                    e?.target?.value
                                  );
                                }
                              }}
                            />
                          </div>
                        </Col>

                        <Col lg={3}>
                          <label>
                            Invoice Pre-Printed Stationary Header Height{" "}
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    Specify the height (in millimeters) of the
                                    header section on pre-printed invoice
                                    stationery. This defines the vertical space
                                    allocated for the header content on the
                                    paper.
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>
                                <i
                                  className="fa fa-info-circle"
                                  style={{
                                    cursor: "pointer",
                                    color: "#9698ab",
                                  }}
                                ></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                          <Field
                            type="number"
                            name="InvoicePrePrintedStationaryHeaderHeight"
                            placeholder={"Height (mm)"}
                            component={CustomInput}
                            onChange={(e) => {
                              if (e?.target?.value < 100) {
                                formik.setFieldValue(
                                  "InvoicePrePrintedStationaryHeaderHeight",
                                  e?.target?.value
                                );
                              }
                            }}
                          />
                        </Col>
                      </Row>
                    </div>
                  </>
                ) : (
                  ""
                )} */}
                {AuthUser?.Permissions?.TestResultFromFile == 1 &&
                (AuthUser?.Permissions?.DT == 1 ||
                  AuthUser?.Permissions?.FoodTesting == 1) ? (
                  <>
                    <hr className="mt-1 mb-1"></hr>
                    <div className="d-flex justify-content-between mb-2">
                      <h5 className="mb-0">Machin Result CSV File Details</h5>
                    </div>
                    <div className="">
                      <Row>
                        <Col lg={3}>
                          <label>
                            Machin Result CSV File Path{" "}
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    Machin Result CSV Absolute File Path.
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>
                                <i
                                  className="fa fa-info-circle"
                                  style={{
                                    cursor: "pointer",
                                    color: "#9698ab",
                                  }}
                                ></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                          <Field
                            name="MachinResultCSVFilePath"
                            placeholder={"CSV File Path"}
                            component={CustomInput}
                            maxLength={1000}
                          />
                        </Col>
                        <Col lg={3}>
                          <label>
                            Machin Result CSV File Read Interval Period(Minutes){" "}
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    Machin Result CSV File Read Set the Interval
                                    Period for File Excuted.
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>
                                <i
                                  className="fa fa-info-circle"
                                  style={{
                                    cursor: "pointer",
                                    color: "#9698ab",
                                  }}
                                ></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                          <Field
                            type="number"
                            name="MachinResultCSVFileReadIntervalPeriod"
                            placeholder={"Enter Interval Period (Minutes)"}
                            component={CustomInput}
                            maxLength={100}
                            onChange={(e) => {
                              if (e?.target?.value < 500) {
                                formik.setFieldValue(
                                  "MachinResultCSVFileReadIntervalPeriod",
                                  e?.target?.value,
                                );
                              }
                            }}
                          />
                        </Col>
                        <Col lg={3}>
                          <label>
                            Machin Result CSV File TCNo Column Name{" "}
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    Machin Result CSV File Column Name.
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>
                                <i
                                  className="fa fa-info-circle"
                                  style={{
                                    cursor: "pointer",
                                    color: "#9698ab",
                                  }}
                                ></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                          <Field
                            name="MachinResultCSVFileTCNoColumnName"
                            placeholder={"Enter Column Name"}
                            component={CustomInput}
                            maxLength={500}
                          />
                        </Col>
                        <Col lg={3}>
                          <label>
                            Machin Result CSV File Test Count Column Name{" "}
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    Machin Result CSV File Test Count Column
                                    Name.
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>
                                <i
                                  className="fa fa-info-circle"
                                  style={{
                                    cursor: "pointer",
                                    color: "#9698ab",
                                  }}
                                ></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                          <Field
                            name="MachinResultCSVFileTestCountColumnName"
                            placeholder={"Enter Test Count Column Name"}
                            component={CustomInput}
                            maxLength={500}
                            required
                          />
                        </Col>
                      </Row>
                    </div>{" "}
                  </>
                ) : (
                  ""
                )}
                <hr className="mt-1 mb-1"></hr>
                <div className="d-flex justify-content-between mb-1">
                  <h5 className="mb-0">Bank Details:</h5>
                  <Link to="#" className="text-primary" onClick={addBank}>
                    + Add Bank
                  </Link>
                </div>
                <Row>
                  <ErrorMessage
                    name={"ListOfBranchBankDetail"}
                    component="div"
                    className="invalid-feedback animated fadeInUp"
                    style={{ display: "block" }}
                  />
                  <Col lg={12}>
                    <div className="table-responsive active-projects style-1 shorting mb-2">
                      <div
                        id="BankDetails-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="BankDetails-tbl"
                          className="table dataTable no-footer mb-0"
                        >
                          <thead>
                            <tr>
                              <th width="4%"></th>
                              <th width="34%">Bank Name</th>
                              <th width="26%">Account No</th>
                              <th width="16%">IFSC Code</th>
                              <th width="20%" style={{ textAlign: "left" }}>
                                Branch
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {ListOfBranchBankDetail?.filter(
                              (x) => x.IsDeleted == false,
                            ).length > 0 ? (
                              ListOfBranchBankDetail?.map((item, indx) => (
                                <tr
                                  key={indx}
                                  style={{
                                    display:
                                      item.IsDeleted == true ? "none" : "",
                                  }}
                                >
                                  <td>
                                    <Link
                                      to="#"
                                      className="icon-box icon-box-md me-1"
                                      title="Edit"
                                      onClick={() => {
                                        editBank(indx);
                                      }}
                                    >
                                      {SVGICON.EditPrimary}
                                    </Link>
                                    <Link
                                      to="#"
                                      className="icon-box icon-box-md me-1"
                                      title="Delete"
                                      onClick={() => {
                                        delete_RecordWithoutApi(
                                          deleteBank,
                                          indx,
                                        );
                                      }}
                                    >
                                      {SVGICON.DeleteDanger}
                                    </Link>
                                  </td>
                                  <td>{item.BankName}</td>
                                  <td>{item.AccountNumber}</td>
                                  <td>{item.IFSCCode}</td>
                                  <td style={{ textAlign: "left" }}>
                                    {item.BranchName}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={5} style={{ textAlign: "left" }}>
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
                <hr className="mt-1 mb-2"></hr>
                <button type="submit" className="btn btn-primary btn-sm me-2">
                  <i className="fa-solid fa-floppy-disk"></i> Submit
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={(e) => {
                    navigate(-1);
                  }}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </button>
              </Form>
            </FormikProvider>
          </div>
        </Spin>
        <Modal className="fade" show={addBankModal} onHide={setAddBankModal}>
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikBankDetail}>
              <Form onSubmit={formikBankDetail.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Bank Details</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setAddBankModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <Field
                        label="Bank Name"
                        name="BankName"
                        placeholder={"Enter Bank Name"}
                        component={CustomInput}
                        maxLength={250}
                        required
                        onChange={(e) => {
                          formikBankDetail.setFieldValue(
                            "BankName",
                            capitalizeString(e?.target?.value),
                          );
                        }}
                      />
                    </Col>
                    <Col lg={12}>
                      <Field
                        label="A/c Number"
                        name="AccountNumber"
                        placeholder={"Enter A/c Number"}
                        component={CustomInput}
                        maxLength={50}
                        required
                      />
                    </Col>
                    <Col lg={12}>
                      <Field
                        label="IFSC Code"
                        name="IFSCCode"
                        placeholder={"Enter IFSC Code"}
                        component={CustomInput}
                        maxLength={50}
                        required
                      />
                    </Col>
                    <Col lg={12}>
                      <Field
                        label="Branch"
                        name="BranchName"
                        placeholder={"Enter Branch"}
                        component={CustomInput}
                        maxLength={100}
                        required
                        onChange={(e) => {
                          formikBankDetail.setFieldValue(
                            "BranchName",
                            capitalizeString(e?.target?.value),
                          );
                        }}
                      />
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="primary btn-sm" type="submit">
                    <i className="fa-solid fa-floppy-disk"></i>{" "}
                    {actionFlag == 1 ? "Update" : "Add"}
                  </Button>
                  <Button
                    variant="danger btn-sm"
                    onClick={() => setAddBankModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
        <QuickAddCategory
          categoryType={categoryType}
          parentCategoryID={parentCategoryID}
          showModal={showQuickAddCategoryModal}
          setShowModal={setShowQuickAddCategoryModal}
          categoryTypeName={categoryTypeName}
          fnCallback={fnCallbackQuickAddCategory}
        />
        <Modal
          className="fade"
          show={showImageModal}
          onHide={setShowImageModal}
          size="lg"
        >
          <Modal.Header>
            <Modal.Title>{imageTitle}</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowImageModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body className="ps-1 pt-0">
            <img src={imageSrc} style={{ maxWidth: imageWidth }} />
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default AddBranch;
